import { Component } from '@angular/core';


@Component({
    selector: 'graph2',
    templateUrl: './test2.component.html',
    styles: [`
        ngx2-cytoscape {
          height: 58vh;
          float: left;
          position: relative;
          width: 56em;
        }
    }`],
})
export class Graph2 {

    htmlID = 'cy2';

    graphData = {
        nodes: [

            { data: { id: 'a', name: 'Carla Velasquez', borderLine: '0', colorText: '#000', classes: 'top' }, position: { x: 500, y: -10 } },
            { data: { id: 'c', name: 'JP', color: '#015fc6', borderLine: '0', colorText: '#fff', classes: 'center' }, position: { x: 10, y: -10 } },
            { data: { id: 'd', type: 'rectangle', name: '1', borderLine: '1', color: '#ff0000', colorText: '#fff', classes: 'center', }, position: { x: -10, y: 200 } },
            { data: { id: 'e', name: 'LP', color: '#2ea999', borderLine: '0', colorText: '#fff', classes: 'center' }, position: { x: -10, y: 400 } },
            { data: { id: 'f2', type: 'rectangle', name: '2', borderLine: '1', color: '#ec9b3b', colorText: '#fff', classes: 'center' }, position: { x: 200, y: 210 } },



        ],

        edges: [
            { data: { id: 'cd', weight: 3, source: 'c', target: 'd', linecolor: '#ff0000' } },
            { data: { id: 'de', weight: 13, source: 'e', target: 'd', linecolor: '#ff0000' } },
            { data: { id: 'af', weight: 5, source: 'a', target: 'f2', linecolor: '#ec9b3b' } },
            { data: { id: 'fe', weight: 6, source: 'f2', target: 'e', linecolor: '#ec9b3b' } },
        ]
    };

    constructor() {

    }

    ngAfterViewInit() {

    }

    testStyle = [
        {
            "selector": "node",
            "style": {
                "shape": "data(type)",
                "width": "mapData(score, 0, 0.006769776522008331, 40, 60)",
                "height": "mapData(score, 0, 0.006769776522008331, 40, 60)",
                "content": "data(name)",
                "font-size": "12px",
                "text-valign": "data(classes)",
                "text-halign": "center",
                "background-color": "data(color)",
                "color": "data(colorText)",
                "overlay-padding": "6px",
                "z-index": "10",
                'border-color': "#000",
                'border-width': "data(borderLine)",
                'pie-size': '100%',
            }
        },
        {
            "selector": "node[points]",
            "style": {
                "shape-polygon-points": "data(points)",
                "label": "polygon\n(custom points)",
                "text-wrap": "wrap",
            },
        },
        {
            selector: 'edge',
            style: {
                'width': 3,
                'line-color': 'data(linecolor)',

            }
        },
        {
            selector: '#a',
            css: {
                'background-image': 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1534&q=80',
                'width': 60,
                'height': 60,
                'background-fit': 'cover',
                'border-color': '#000',
                'border-width': 3,
                'border-opacity': 0.5
            }
        },
        {
            selector: ':parent',
            css: {
                'text-valign': 'top',
                'text-halign': 'center',
            }
        }
    ];

    layoutTes = {
        name: 'preset',
        directed: false,
        roots: '#a',
    }

    // the default values of each option are outlined below:
    defaults = {
        zoomFactor: 0, // zoom factor per zoom tick
        zoomDelay: 45, // how many ms between zoom ticks
        minZoom: 0.1, // min zoom level
        maxZoom: 10, // max zoom level
        fitPadding: 50, // padding when fitting
        panSpeed: 10, // how many ms in between pan ticks
        panDistance: 10, // max pan distance per tick
        panDragAreaSize: 75, // the length of the pan drag box in which the vector for panning is calculated (bigger = finer control of pan speed and direction)
        panMinPercentSpeed: 0.25, // the slowest speed we can pan by (as a percent of panSpeed)
        panInactiveArea: 8, // radius of inactive area in pan drag box
        panIndicatorMinOpacity: 0.5, // min opacity of pan indicator (the draggable nib); scales from this to 1.0
        zoomOnly: false, // a minimal version of the ui only with zooming (useful on systems with bad mousewheel resolution)
        fitSelector: undefined, // selector of elements to fit
        animateOnFit: function () { // whether to animate on fit
            return false;
        },
        fitAnimationDuration: 1000, // duration of animation on fit

        // icon class names
        sliderHandleIcon: 'fa fa-minus',
        zoomInIcon: 'fa fa-plus',
        zoomOutIcon: 'fa fa-minus',
        resetIcon: 'fa fa-expand'
    };

    boxSelectionEnabled: false;
    autounselectify: true;
}
